import type { MailboxInfo } from 'owa-client-types';
import type { OutlookCloudPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';
import { isPoliciesEnabledForAccount } from '../utils/isPoliciesEnabledForAccount';
import { getPolicyDataBySettingId } from './getPolicyDataBySettingId';

export function isOcpsPolicyEnabled(
    settingId: OutlookCloudPolicySettingId,
    mailboxInfo: MailboxInfo,
    enabledIfUndefined?: boolean
): boolean {
    if (!isPoliciesEnabledForAccount(mailboxInfo)) {
        return enabledIfUndefined ?? true;
    }
    const policyData = getPolicyDataBySettingId(mailboxInfo, settingId);
    return policyData ? policyData.value === '1' : enabledIfUndefined ?? false;
}
